<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option v-for="m in selects" :key="m.month" :value="m.month" :selected="m.month == selected">{{
      m.month
    }}</option>
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectMonths',
  data() {
    return {
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
      isPartialInvoice:this.partialInvoice ? this.partialInvoice : 0,
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    partialInvoice: {
      type: String,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/invoice/months/${this.isPartialInvoice}`).then(
        (res) => (this.selects = res.data)
      );
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
